/**
 * Where an article is read. News are articles too (`is_news`), but they have a
 * page of their own; a link built as /article/:id for one shows it in the
 * article layout.
 */
export function articlePath(article) {
  return article?.is_news
    ? `/news/${article.article_id}`
    : `/article/${article.article_id}`;
}
